export const MEDIA_PREFERS_REDUCED_MOTION = '(prefers-reduced-motion: reduce)';